import { Box } from '@mui/material';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { deDE } from '@mui/x-data-grid/locales';
import { get } from 'lodash';
import React, { FC, useMemo } from 'react';
import { useApplication } from 'src/context/ApplicationContext';
import { KOSTEN_ARTEN, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { DisplayDecimal, DisplayEuroMUI } from 'src/utils/formats';
import { isTrue } from 'src/utils/helper';
import ApplicationHeading from '../../../../../application-heading/ApplicationHeading';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
import kostenPositionSchema from 'src/lib/paths/kostenposition_FULL_Paths.json';
import { getUnternehmenDisplayName } from 'src/utils/ausgabenFinanzierungHelper';
const P = Schema.attributes;
const KP_P = kostenPositionSchema.attributes;

const PersonalkostenUebersichtSkizzeLoewe: FC<{}> = () => {
	const { application } = useApplication();
	const columns = [
		// { field: 'id', headerName: 'ID', width: 80, groupable: false },
		{ field: 'unternehmen', headerName: 'Unternehmen / Institution', width: 200, groupable: false },
		{ field: 'name', headerName: 'Name', width: 500, groupable: false },
		{ field: 'qualifikation', headerName: 'Funktion im geplanten Projekt', flex: 1 },
		{
			field: 'stundensatz',
			headerName: 'Stundensatz',
			width: 120,
			type: 'number' as const,
			valueFormatter: (value: any) => {
				return value ? DisplayEuroMUI(value) : null;
			},
		},
		{
			field: 'stundengeplannt',
			headerName: 'Geplante Projektstunden',
			width: 180,
			type: 'number' as const,
			valueFormatter: (value: any) => {
				return value ? DisplayDecimal(value) : null;
			},
		},
		{
			field: 'geplanteSumme',
			headerName: 'Geplante Summe',
			width: 160,
			type: 'number' as const,
			valueFormatter: (value: any) => {
				return value ? DisplayEuroMUI(value) : null;
			},
		},
	];
	const rows = useMemo(() => {
		let row = get(application, P.Foerderantrag_Kostenpositions.path, [])
			.filter((ele: any) => get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Personalkosten)
			.map((ele: any) => {
				return {
					id: get(ele, 'id'),
					kostraeger: get(ele, KP_P.Allgemein_Kostentraeger.path, ''),
					unternehmen: getUnternehmenDisplayName(application, ele),
					kostenKategorie: get(ele, KP_P.Allgemein_Kostenkategorie.schema.attributes.Allgemein_Bezeichnung.path),
					qualifikation: get(ele, KP_P.Personalausgaben_LOEWE_Skizze.schema.attributes.Qualifikation_Funktion.path, ''),
					name: get(ele, KP_P.Allgemein_Bezeichnung.path, ''),
					stundensatz: get(ele, KP_P.Personalausgaben_LOEWE_Skizze.schema.attributes.Stundensatz.path, ''),
					stundengeplannt: get(ele, KP_P.Personalausgaben_LOEWE_Skizze.schema.attributes.Geplante_Stunden_Im_Projekt.path, ''),
					geplanteSumme: get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path),
					isAdminPauschale: isTrue(get(ele, KP_P.Personalausgaben_LOEWE_Antrag.schema.attributes.Administrationspauschale.path, false)),
				};
			})
			.sort((a: any, b: any) => {
				// Innerhalb der gleichen Gruppe (unternehmen): Administrationspauschale immer am Ende
				// Administrationspauschale ist die 20% Pauschale für HAW, die im Akkordion nicht angezeigt werden müssen.
				// Das wird per Formel ausgerechnet bzw. angelegt, wenn die Antragstellende ein HAW ist.
				if (a.unternehmen === b.unternehmen) {
					return Number(a.isAdminPauschale) - Number(b.isAdminPauschale);
				}
				return 0;
			});
		return row;
	}, [application]);

	const initialState: any = useMemo(() => {
		return {
			aggregation: {
				model: { stundengeplannt: 'sum', geplanteSumme: 'sum' },
			},
			columns: {
				columnVisibilityModel: {
					// Hide the column used for leaves
					unternehmen: false,
				},
			},
			rowGrouping: {
				model: ['unternehmen'],
			},
		};
	}, []);

	return (
		<>
			<ApplicationHeading title='	Personalausgaben Übersicht' description={PLATZHALTER_TEXT} />
			<Box sx={{ height: 'auto' }}>
				<DataGridPremium
					rows={rows}
					columns={columns}
					initialState={initialState}
					groupingColDef={{
						headerName: 'Organisation',
						valueFormatter: (value: any) => value ?? 'Gesamt',
					}}
					hideFooter
					defaultGroupingExpansionDepth={-1}
					localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
				/>
			</Box>
		</>
	);
};
export default PersonalkostenUebersichtSkizzeLoewe;
